import {jwtDecode, JwtPayload} from "jwt-decode";
import {UserProfile} from "@/models/user.ts";

type NbhJwtPayload = JwtPayload & {
    userId?: string;
    role?: "USER" | "ADMIN";
};

export function tokenIsStillValid(token: string): boolean {
    if (!token) {
        return false;
    }
    try {
        const {exp} = jwtDecode<JwtPayload>(token);
        if (typeof exp !== "number") {
            return false;
        }
        return Date.now() < exp * 1000;
    } catch {
        return false;
    }
}

export function readUserFromToken(token: string): UserProfile | null {
    try {
        const {sub, userId, role} = jwtDecode<NbhJwtPayload>(token);
        if (!sub || !userId || (role !== "USER" && role !== "ADMIN")) {
            return null;
        }
        return {userName: sub, userId, role};
    } catch {
        return null;
    }
}
